export default "__VITE_ASSET__CTwJ8HmI__"